import {flow, getEnv, getType, types} from "mobx-state-tree";
import {createDefaultSettingModel, DefaultSettingModel} from "../../models/defaultSetting/DefaultSettingModel";

const DefaultSettingStore = types.model('DefaultSettingStore',{
  storeUuid: types.identifier,
  defaultSettings: types.optional(types.array(DefaultSettingModel), []),
}).volatile((self)=>({
  filterListOn: types.fn,
})).actions((self) => ({
  setFilterOn(funct) {
    self.filterListOn = funct;
  },
  setDefaultSetting(data) {
    self.defaultSettings = data?.map((item) => {
      if(item.status ==="ACTIVE") {
        return createDefaultSettingModel(item, self)
      }
    });
    self.sortDefaultSettings();
  },
  initWithData(data = []) {
    try {
      if (data) {
        self.setDefaultSetting(data);
      }
    } catch (e) {
      console.error(`${getType(self).name} Error: Failed to initWithData`, e);
    }
  },
  init: flow(function* (queryParams = {}) {
    const response = yield getEnv(self).defaultSettingManager.fetchAll(queryParams, self);
    self.initWithData(response?.results);
  }),
  sortDefaultSettings() {
    try {
      self.defaultSettings?.sort((a, b) => a.label.localeCompare(b.label));
    } catch (e) {
      console.warn(`${getType(self).name} Warn: Failed to sort`, e);
    }
  }
})).views((self) => ({
  getDefaultSettings() {
    if (self.filterListOn) {
      return self.defaultSettings.filter(self.filterListOn);
    } else {
      return self.defaultSettings;
    }
  }
}));

export default DefaultSettingStore;
